/* ME × Liza — 17.09.2026: zmiana koloru w buy boxie na stronie Lizy BEZ przechodzenia na kartę produktu.
   Klik w miniaturę koloru -> pobiera ten sam buy box dla wybranego koloru z szablonu product.liza-fp
   i podmienia go mechanizmem motywu (product:rerender).
   Wariant: to samo wykończenie + 2,8 mm + Lips; jeśli niedostępne — dostępne drugie wykończenie (2,8 mm + Lips). */
(function () {
  if (window.__meLizaSwap) return;
  window.__meLizaSwap = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var jsonCache = {};
  function productJson(handle) {
    if (!jsonCache[handle]) jsonCache[handle] = fetch(root + 'products/' + handle + '.js').then(function (r) { return r.json(); });
    return jsonCache[handle];
  }
  function handleFromHref(href) {
    var m = new URL(href, location.origin).pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function pickVariant(target, curOptions) {
    var same = function (v) { return v.options.join('|') === curOptions.join('|'); };
    var sameConfig = function (v) { return v.options.slice(1).join('|') === curOptions.slice(1).join('|'); };
    return target.variants.find(function (v) { return same(v) && v.available; })
      || target.variants.find(function (v) { return sameConfig(v) && v.available; })
      || target.variants.find(same)
      || target.variants.find(sameConfig);
  }
  document.addEventListener('click', async function (e) {
    if (!document.body.classList.contains('me-liza-page')) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a[href*="/products/"]');
    if (!a) return;
    var section = a.closest('.shopify-section--featured-product');
    if (!section || !a.closest('.variant-picker__option-values')) return;
    var rr = section.querySelector('product-rerender');
    if (!rr) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (a.classList.contains('is-selected')) return;
    var handle = handleFromHref(a.href);
    var formId = rr.getAttribute('observe-form');
    var form = document.forms[formId];
    var idInput = document.querySelector('[name="id"][form="' + formId + '"]') || (form && form.querySelector('[name="id"]'));
    var titleLink = rr.querySelector('.product-info__title a[href*="/products/"]');
    var currentHandle = titleLink ? handleFromHref(titleLink.href) : null;
    if (!handle || !form) { location.href = a.href; return; }
    rr.classList.add('me-swap-loading');
    try {
      var variantId = '';
      if (idInput && currentHandle) {
        var cur = await productJson(currentHandle);
        var curVariant = cur.variants.find(function (v) { return String(v.id) === String(idInput.value); });
        if (curVariant) {
          var match = pickVariant(await productJson(handle), curVariant.options);
          if (match) variantId = match.id;
        }
      }
      var url = root + 'products/' + handle + '?view=liza-fp' + (variantId ? '&variant=' + variantId : '');
      var html = await fetch(url).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); });
      var newIdMatch = html.match(/id="shopify-section-([^"]*featured_product[^"]*)"/);
      var oldId = section.id.replace('shopify-section-', '');
      if (!newIdMatch) throw new Error('no section');
      html = html.split(newIdMatch[1]).join(oldId);
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newRr = doc.getElementById(rr.id);
      if (!newRr) throw new Error('no rerender');
      var y = window.scrollY;
      var fragment = document.createRange().createContextualFragment(newRr.outerHTML);
      form.dispatchEvent(new CustomEvent('product:rerender', { detail: { htmlFragment: fragment, productChange: true } }));
      window.scrollTo(0, y);
      document.dispatchEvent(new CustomEvent('me-liza:color-changed', { detail: { handle: handle, variantId: variantId } }));
    } catch (err) {
      console.warn('[me-liza-swap]', err);
      location.href = a.href;
    } finally {
      var live = section.querySelector('product-rerender');
      if (live) live.classList.remove('me-swap-loading');
    }
  }, true);
})();